<script lang="ts">
    import {getInjector, getLocalization} from 'src/core';
    import type {OpeningCalendarData, ViewableOpeningCalendarData} from './types';
    import KpGenericPanel from '../../ui-widgets/panel/KpGenericPanel.svelte';
    import {exists, isNullOrUndefined} from '../../utils/custom-utils';
    import {normalizeRanges} from './utils';
    import OpeningCalendarDataService from './kp-opening-calendar.data-service';

    export let calendarData: OpeningCalendarData | null = null;
    export let calendarDataSource: string = null;
    export let showWeekend: boolean | 'auto' = 'auto';
    export let departmentId: number = null;

    let data: ViewableOpeningCalendarData;

    const localize = getLocalization();
    const injector = getInjector();
    const openingCalendarApiUrl = injector.getByToken<string>('openingCalendarApiUrl');
    const openingCalendarDataService = getInjector().getByClass(OpeningCalendarDataService);

    if (isNullOrUndefined(calendarData)) {
        fetchCalendarData();
    } else {
        data = normalizeRanges(calendarData, showWeekend);
    }

    async function fetchCalendarData() {
        const rawData = await openingCalendarDataService.getOpeningHours(calendarDataSource ?? openingCalendarApiUrl, departmentId ?? undefined);
        data = normalizeRanges(rawData, showWeekend)
    }
</script>

{#if exists(data)}
    <KpGenericPanel additionalClasses="kp-opening-calendar">
        <div slot="heading" class="calendar-heading">
            <slot>
                <h2 class="unset-style">
                    <strong>{localize(/* @kp-localization commons.ProvozniDoba */ 'commons.ProvozniDoba')}</strong>
                </h2>
            </slot>
            {#if data.notice}
                <div class="notice">
                    <strong>{data.notice}</strong>
                </div>
            {/if}
        </div>

        <table>
            <tbody>
                {#each data.days as day}
                    <tr class:current-day={day.current}>
                        <td class="day-name">{day.dayText}</td>
                        {#each day.ranges as range}
                            <td>
                                {#if (exists(range))}
                                    <span>{range.fromTime} - {range.toTime}</span>
                                {/if}
                            </td>
                        {/each}
                    </tr>
                {/each}
            </tbody>

            <tfoot>
                {#each data.notes as note}
                    <tr class="calendar-note">
                        <td colspan={data.count + 1}>{note}</td>
                    </tr>
                {/each}
            </tfoot>
        </table>
    </KpGenericPanel>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    :global(.kp-opening-calendar) {
        // calc(100% - 20px) to completely fill container including 20px panel margin (without leaking margin outside of container)
        height: calc(100% - @line-height-computed);
    }

    .calendar-heading {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .notice {
            margin-left: auto;
        }
    }

    table {
        width: 100%;
    }

    .current-day {
        font-weight: bold;
    }

    .day-name {
        padding-right: 10px;
    }

    tfoot .calendar-note:first-child td {
        // tfoot and tr do not allow padding and tfoot tr:first-child td is bugged in svelte
        padding-top: 10px;
    }
</style>